// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "select[data-v-7105b559]{height:100%;width:100%;-webkit-appearance:none;-moz-appearance:none;appearance:none;--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity));padding-right:1.5rem;outline:2px solid transparent;outline-offset:2px}", ""]);
// Exports
module.exports = exports;
